import permissions from './permissions';
import { PermissionsObject } from './types';

/**
 * Encode a descriptive permissions object into a numerical (binary) representation
 * @param {object} permissions An object containing permission-names as properties with a boolean value
 */
export function encode(permObj: Partial<PermissionsObject>) {
  // throw an error of user is trying to encode any unknown permissions
  // or if keys contain non boolean values
  var permInt = 0;
  let key: keyof PermissionsObject;
  for (key in permObj) {
    if (permObj.hasOwnProperty(key)) {
      var element = permObj[key];
      if (!permissions[key]) {
        throw new Error('Cannot encode unknown permission ' + key + "'");
      }
      if (typeof element !== 'boolean') {
        throw new Error(
          'Refuses to encode permissions-object with non-boolean value',
        );
      }
      if (element) {
        permInt += permissions[key];
      }
    }
  }
  return permInt;
}

/**
 * Decodes an encoded permissions object
 * @param {number} permissions A encoded permissions object
 */
export function decode(permInt: number) {
  if (typeof permInt !== 'number') {
    throw new Error('Expected argument to be an number');
  }
  var permObj: Partial<PermissionsObject> = {};
  let permission: keyof PermissionsObject;
  for (permission in permissions) {
    if (permissions.hasOwnProperty(permission)) {
      var bitmask = permissions[permission];
      permObj[permission] = !!(bitmask & permInt);
    }
  }
  return permObj as PermissionsObject;
}
